import { render, staticRenderFns } from "./informationDangerousGoods.vue?vue&type=template&id=64f92578&"
import script from "./informationDangerousGoods.vue?vue&type=script&lang=js&"
export * from "./informationDangerousGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports